//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CFWDPH',
  data() {
    return {
      form: {
        age: '',
        weight: '',
        targetBlood: '',
        measureBlood: ''
      },
      ageList: [
        {
          value: "男<65岁", name: "男<65岁"
        },
        {
          value: "男≥65岁", name: "男≥65岁"
        },
        {
          value: "女<18岁", name: "女<18岁"
        },
        {
          value: "女18~65岁", name: "女18~65岁"
        },
        {
          value: "女≥65岁", name: "女≥65岁"
        },
      ],
      hasScore: false,
      disabled: false,
    }
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      console.log(form.age);
      if (form.age == '男<65岁') {
        form.age = "0.6"
      } else if (form.age == '男≥65岁') {
        form.age = "0.5"
      } else if (form.age == '女<18岁') {
        form.age = "0.6"
      } else if (form.age == '女18~65岁') {
        form.age = "0.5"
      } else if (form.age == '女≥65岁') {
        form.age = "0.45"
      }
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
      } else {
        let result = (form.age * form.weight) * (form.measureBlood - form.targetBlood) / form.targetBlood
        self.hasScore = true
        return String(result + 'L')
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/CFWDPH.vue